
import { langue } from '~/assets/js/utiles.js'

export default {
  data () {
    return {
      portesOuvertesSram: [],
      filtre: null
    }
  },
  async fetch () {
    const langueTraduction = langue(this.$i18n.locale)
    const url =
      `${this.$config.pygmaUrl}/api/portes_ouvertes/` +
      langueTraduction.substring(0, 2)
    const resultat = await this.$axios.$get(url)

    function compare (a, b) {
      if (a.ordre_tri < b.ordre_tri) {
        return -1
      }
      if (a.ordre_tri > b.ordre_tri) {
        return 1
      }
      return 0
    }

    const portes = resultat.sort(compare)
    this.portesOuvertesSram = portes
  },
  computed: {
    listePortesOuvertesFiltrees: function () {
      if (this.filtre && this.filtre.length > 0) {
        return this.portesOuvertesSram.filter((porteOuverte) => {
          return porteOuverte.nom_college.toLowerCase().includes(this.filtre.toLowerCase())
        })
      } else {
        return this.portesOuvertesSram
      }
    }
  }

}
